import { OrderEditProduct, OrderEditDiscount } from './components/Products';

export function getEditionDetails(
  editedOrderProducts: OrderEditProduct[],
  editedOrderDiscounts: OrderEditDiscount[],
) {
  const addsDiscounts = editedOrderDiscounts.some(
    ({ editType }) => editType === 'add',
  );
  const removesDiscounts = editedOrderDiscounts.some(
    ({ editType }) => editType === 'remove',
  );

  let addedProductsQty = 0;
  let removedProductsQty = 0;
  editedOrderProducts.forEach((editedProduct) => {
    if (editedProduct.editType === 'add') {
      addedProductsQty += editedProduct.quantity;
    }
    if (editedProduct.editType === 'delete') {
      removedProductsQty += editedProduct.quantity;
    }

    const qtyDiff =
      editedProduct.quantity - (editedProduct.originalQuantity ?? 0);
    if (editedProduct.editType === 'edit' && qtyDiff !== 0) {
      if (qtyDiff > 0) {
        addedProductsQty += qtyDiff;
      } else {
        removedProductsQty -= qtyDiff;
      }
    }
  });

  return {
    addedProductsQty,
    removedProductsQty,
    addsDiscounts,
    removesDiscounts,
  };
}
